/** Picks v2 or v1 of General App Settings based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import GeneralSettingsPage   from './GeneralSettingsPage';
import GeneralSettingsPageV2 from './v2/GeneralSettingsPageV2';

export default function GeneralSettingsPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? GeneralSettingsPageV2 : GeneralSettingsPage;
  return <Component {...props} />;
}
